import Button from "@/components/Button";
import SimpleDropdown from "@/components/dropdowns/SimpleDropdown/SimpleDropdown";
import Toolbar from "@/containers/Toolbar";
import { favorite, filterIcon, shareIcon } from "@/designSystemIcons";
import { TacticsSidePanelOption } from "@/features/Tactics/TacticsSidePanel";
import { TacticSortOption } from "@/redux/tactics/tacticsSlice";
import { BREAKPOINTS } from "@/settings";
import Oval from "react-loading-icons/dist/esm/components/oval";
import { useMediaQuery } from "usehooks-ts";

interface TacticToolbarProps {
  isFavoriteFilterOn: boolean;
  panelState: TacticsSidePanelOption;
  currentSortBy: TacticSortOption;
  loading: boolean;
  canUploadTactic: boolean;
  handleFiltersClicked: () => void;
  handleFavoriteClicked: () => void;
  handleSortByChanged: (option: TacticSortOption) => void;
  handleUploadTacticsClicked: () => void;
}

const TACTIC_SORT_OPTIONS: TacticSortOption[] = [
  { label: "Recommended", value: "recommended" },
  { label: "Date Added", value: "date-added" },
  { label: "Popularity Score", value: "popularity-score" },
];

const TacticToolbar = ({
  isFavoriteFilterOn,
  panelState,
  currentSortBy,
  loading,
  canUploadTactic,
  handleFiltersClicked,
  handleFavoriteClicked,
  handleSortByChanged,
  handleUploadTacticsClicked,
}: TacticToolbarProps) => {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);
  return (
    <Toolbar>
      <div className="flex flex-row justify-between w-full">
        <div className="flex flex-row gap-x-2 items-center">
          <Button
            variant="tertiary"
            label="Filters"
            active={panelState === "filters"}
            icon={<div className="w-5 h-5">{filterIcon}</div>}
            onClick={handleFiltersClicked}
            isMobileFilterButton={isMobile}
          />
          <div className="h-6 w-[1px] bg-new-gray-750 my-auto hidden touch-device:block" />
          {!isMobile && (
            <Button
              variant="tertiary"
              label="Favorites"
              active={isFavoriteFilterOn}
              icon={<div className="w-4 h-4">{favorite}</div>}
              onClick={(e) => {
                e.stopPropagation();
                handleFavoriteClicked();
              }}
            />
          )}
          {canUploadTactic && (
            <Button
              onClick={(e) => {
                e.stopPropagation();
                handleUploadTacticsClicked();
              }}
              variant="tertiary"
              label="Upload New Tactic"
              icon={<div className="w-5 h-5">{shareIcon}</div>}
            />
          )}
          {loading && <Oval width={20} height={20} />}
        </div>
        <div className="flex flex-row items-center text-sm gap-x-2 text-dark-tertiary">
          <span className="hidden desktop:block">Sort by:</span>
          <SimpleDropdown
            variant="tertiary"
            options={TACTIC_SORT_OPTIONS}
            selectedOption={currentSortBy}
            onChange={(option) =>
              handleSortByChanged(option as TacticSortOption)
            }
          />
        </div>
      </div>
    </Toolbar>
  );
};

export default TacticToolbar;
